const INVESTOR = 'investor';
const ADVISOR = 'advisor';
const SUPER_ADMIN = 'super-admin';

export default {
    INVESTOR,
    ADVISOR,
    SUPER_ADMIN,
};
